import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  useEffect(() => {
    document.title = "404 - Siden blev ikke fundet | Fyns Afløbsteknik ApS";
  }, []);

  return (
    <div className="bg-[#0d1117] text-white min-h-[70vh] flex items-center justify-center py-20 px-4">
      <div className="max-w-xl text-center space-y-6">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-neutral-800/80 border border-neutral-700 text-neutral-300 text-3xl shadow-xl">
          <i className="fa-solid fa-triangle-exclamation" aria-hidden="true" />
        </div>

        <span className="text-xs uppercase font-bold tracking-widest text-neutral-400 block">
          Fejl 404 – Siden blev ikke fundet
        </span>

        <h1 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
          Siden blev desværre ikke fundet
        </h1>

        <p className="text-neutral-300 text-sm sm:text-base leading-relaxed">
          Siden du leder efter findes ikke længere, eller adressen er blevet flyttet. Brug linksene herunder for at finde det rette indhold på vores hjemmeside.
        </p>

        <div className="pt-2 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="bg-white hover:bg-neutral-200 text-black font-bold px-6 py-3 rounded-lg text-sm transition-colors shadow-lg flex items-center gap-2"
          >
            <i className="fa-solid fa-house" aria-hidden="true" />
            <span>Gå til forsiden</span>
          </Link>

          <Link
            to="/kontakt"
            className="bg-neutral-800 hover:bg-neutral-700 text-white font-medium px-6 py-3 rounded-lg text-sm transition-colors border border-neutral-700 flex items-center gap-2"
          >
            <i className="fa-solid fa-envelope" aria-hidden="true" />
            <span>Kontakt os</span>
          </Link>
        </div>

        <div className="pt-8 border-t border-neutral-800 text-xs text-neutral-400">
          <span>Har du brug for akut kloakhjælp? Ring direkte på </span>
          <a href="tel:50493950" className="text-white font-bold underline hover:text-neutral-300 no-break">
            50 49 39 50
          </a>
        </div>
      </div>
    </div>
  );
}
